<script setup lang="ts">
import type { Initiative } from '~/types/initiatives'

const props = defineProps<{
  initiative?: Initiative
}>()

// Sidebar state management
const isSidebarOpen = ref(false)
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value
}

const { menuItems, bottomItems } = useSidebarItems(toRef(props, 'initiative'))
</script>

<template>
  <UDashboardGroup unit="rem">
    <TheSidebar
      :is-open="isSidebarOpen"
      :menu-items="menuItems"
      :bottom-items="bottomItems"
    />

    <main
      class="flex w-full flex-col overflow-y-auto bg-white p-4 lg:w-[calc(100%-11rem)]"
    >
      <div class="flex items-center gap-2">
        <UDashboardSidebarToggle
          :is-open="isSidebarOpen"
          @toggle="toggleSidebar"
          class="flex-shrink-0"
        />
      </div>
      <slot />
    </main>
  </UDashboardGroup>
</template>
